import User from '../views/user/personal-center/personal-center'
import Login from '../views/user/login/login'
import Register from '../views/user/register/register'
import ForgetPwd from '../views/user/forget-pwd/forget-pwd'
import PersonalSet from '../views/user/personal-set/personal-set'
import AccountSet from '../views/user/account-set/account-set'
import AddAddress from '../views/user/add-address/add-address'
import ReceivingAddr from '../views/user/receiving-addr/receiving-addr'
const UserRouter = [
  // 用户中心
  {
    path: '/personal-center',
    name: 'personal-center',
    component: User,
    meta: { keepAlive: true }
  },
  // 登陆
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  // 注册
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  // 忘记密码
  {
    path: '/forget-pwd',
    name: 'forget-pwd',
    component: ForgetPwd
  },
  // 个人设置
  {
    path: '/personal-set',
    name: 'personal-set',
    component: PersonalSet,
    meta: { keepAlive: true }
  },
  // 账号设置
  {
    path: '/account-set',
    name: 'account-set',
    component: AccountSet
  },
  // 收货地址编辑，新增收货地址
  {
    path: '/add-address',
    name: 'add-address',
    component: AddAddress
  },
  // 收货地址
  {
    path: '/receiving-addr',
    name: 'receiving-addr',
    component: ReceivingAddr
  },

]

export default UserRouter
